export default __webpack_public_path__ + "static/media/oval.2cbed768.webp";